import { render, staticRenderFns } from "./FullTradeImage.vue?vue&type=template&id=fe3abd98&scoped=true"
import script from "./FullTradeImage.vue?vue&type=script&lang=js"
export * from "./FullTradeImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3abd98",
  null
  
)

export default component.exports